<template>
  <vx-card :title="title">
    <vs-tabs :value="active">
      <vs-tab label="Customer">
        <Customers></Customers>
      </vs-tab>
      <vs-tab label="Customer Shipto">
        <CustomerShipto></CustomerShipto>
      </vs-tab>
    </vs-tabs>
  </vx-card>
</template>
<script>

import Customers from "./customer/index.vue";
import CustomerShipto from "./customer-shipto/index.vue";

export default {
  props: {
    active: {
      type: Number,
    },
  },
  components: {
    Customers,
    CustomerShipto,
  },
  data() {
    return {
      title: "Bulk Update Master",
    };
  },
};
</script>
